import api from '../api';

export const deserializeLooseItemsApi = (params) =>
  api.post('/LooseItems/Deserialized', params).then((res) => res);

export const getTemplateApi = (params) =>
  api.get('/LooseItems/Deserialized', params).then((res) => res);
